export default "<a href=\"#\" class=\"back-to-top rounded text-center\" id=\"back-to-top\">\n    <mat-icon svgIcon=\"chevron-up\"></mat-icon>\n</a>"